var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.container},[_c('article',{class:_vm.$style.videoContainer,domProps:{"innerHTML":_vm._s(_vm.primary.embed_video && _vm.primary.embed_video.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }